import _IconClose from "@arco-design/iconbox-react-m4b-next/esm/IconClose";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import cs from 'classnames';
import { Spin } from '@arco-design/web-react';
import Button from '@m4b-design/button';
import { useConfigContext } from '@m4b-design/config-provider';
import Grid from './grid';
import './style/card.less';
import { useInfo } from './hooks';
import { DefaultIcon } from './svg';
var defaultProps = {
  direction: 'horizontal',
  shadow: true,
  icon: true
};
function Card(baseProps, ref) {
  var _a, _b, _c;
  var _d = __read(useState(true), 2),
    visible = _d[0],
    setVisible = _d[1];
  var globalPrefixCls = useConfigContext().prefixCls;
  var props = __assign(__assign({}, defaultProps), baseProps);
  var shadow = props.shadow,
    bordered = props.bordered,
    hoverable = props.hoverable,
    className = props.className,
    direction = props.direction,
    children = props.children,
    title = props.title,
    subtitle = props.subtitle,
    time = props.time,
    loading = props.loading,
    subStyle = props.subStyle,
    subClassName = props.subClassName,
    closeIcon = props.closeIcon,
    icon = props.icon,
    headerStyle = props.headerStyle,
    headerClassName = props.headerClassName,
    bodyStyle = props.bodyStyle,
    bodyClassName = props.bodyClassName,
    action = props.action,
    actionOption = props.actionOption,
    closable = props.closable,
    extra = props.extra,
    cover = props.cover,
    onClose = props.onClose,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _ = props.infoMode,
    rest = __rest(props, ["shadow", "bordered", "hoverable", "className", "direction", "children", "title", "subtitle", "time", "loading", "subStyle", "subClassName", "closeIcon", "icon", "headerStyle", "headerClassName", "bodyStyle", "bodyClassName", "action", "actionOption", "closable", "extra", "cover", "onClose", "infoMode"]);
  var prefixCls = "".concat(globalPrefixCls, "-card");
  var _e = useInfo({
      prefixCls: prefixCls,
      cardProps: props
    }),
    isInfoMode = _e.isInfoMode,
    infoModeElement = _e.element;
  var isContainGrid = false;
  var handleVisible = function handleVisible(e) {
    setVisible(false);
    onClose && onClose(e);
  };
  var handledChildren = React.Children.map(children, function (element) {
    if (element && element.type) {
      if (element.type === Grid) {
        isContainGrid = true;
        return /*#__PURE__*/React.cloneElement(element, {
          direction: direction
        });
      }
    }
    return element;
  });
  if (!visible) {
    return null;
  }
  var LoadingBox = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-loading-box")
  }, /*#__PURE__*/React.createElement(Spin, null));
  var Content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-box-info"))
  }, title && /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-info-title"), "".concat(prefixCls, "-info-item"), headerClassName),
    style: headerStyle
  }, title), subtitle && /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-info-subtitle"), "".concat(prefixCls, "-info-item"), subClassName),
    style: subStyle
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-info-desc"), "".concat(prefixCls, "-info-item"), (_a = {}, _a["".concat(prefixCls, "-only-child")] = !title && !subtitle, _a), bodyClassName),
    style: bodyStyle
  }, loading ? LoadingBox : isInfoMode ? infoModeElement : /*#__PURE__*/React.createElement(React.Fragment, null, handledChildren, time && /*#__PURE__*/React.createElement("span", {
    className: cs("".concat(prefixCls, "-info-desc-time"))
  }, time)))), action ? /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-action"))
  }, action) : actionOption && actionOption.length ? /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-action"))
  }, actionOption.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-button"),
      key: i
    }, /*#__PURE__*/React.createElement(Button, __assign({}, item, {
      size: "mini"
    })));
  })) : null);
  return /*#__PURE__*/React.createElement("div", __assign({}, rest, {
    ref: ref,
    className: cs(prefixCls, "".concat(prefixCls, "-direction-").concat(direction), (_b = {}, _b["".concat(prefixCls, "-loading")] = loading, _b["".concat(prefixCls, "-shadow")] = shadow, _b["".concat(prefixCls, "-bordered")] = bordered, _b["".concat(prefixCls, "-hoverable")] = hoverable, _b["".concat(prefixCls, "-contain-grid")] = isContainGrid, _b), className),
    "data-tid": "m4b_card"
  }), cover ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-cover")
  }, cover) : /*#__PURE__*/React.createElement(React.Fragment, null, icon && !isContainGrid && /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-icon"))
  }, icon === true ? /*#__PURE__*/React.createElement(DefaultIcon, null) : icon)), /*#__PURE__*/React.createElement("div", {
    className: cs("".concat(prefixCls, "-box"))
  }, Content), (extra || closable) && !isContainGrid && /*#__PURE__*/React.createElement("span", {
    className: cs("".concat(prefixCls, "-close"), (_c = {}, _c["".concat(prefixCls, "-close-extra")] = extra, _c["".concat(prefixCls, "-close-icon")] = !extra && closable, _c)),
    onClick: !extra && closable ? handleVisible : undefined
  }, !extra ? closable && /*#__PURE__*/React.createElement("span", null, closeIcon || /*#__PURE__*/React.createElement(_IconClose, null)) : /*#__PURE__*/React.createElement("span", null, extra)));
}
var ForwardRefCard = /*#__PURE__*/React.forwardRef(Card);
var CardComponent = ForwardRefCard;
CardComponent.Grid = Grid;
CardComponent.displayName = 'Card';
export default CardComponent;